import { Injectable } from '@angular/core';
import { ActivatedRoute, QueryParamsHandling, Router } from '@angular/router';
import { Location } from '@angular/common';
import { APP_QUERY_PARAMS, ROOT_ROUTES } from '../configurations/router.config';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly location: Location,
  ) {}

  getUrlForStartNextSession(): string {
    const url = this.location.path();

    return url.includes(ROOT_ROUTES.forbidden) || url.includes(ROOT_ROUTES.notFound) || url.includes(ROOT_ROUTES.signIn)
      ? ''
      : url;
  }

  navigateBySiteId(siteId: number): void {
    if (!siteId) return;

    void this.navigateByQueryParams({ [APP_QUERY_PARAMS.siteId]: siteId });
  }

  navigateByAccountId(accountId: number): void {
    if (!accountId) return;

    void this.navigateByQueryParams({ [APP_QUERY_PARAMS.accountId]: accountId });
  }

  navigateByAccountsAndSites(accounts: string | null, sites: string | null): void {
    void this.navigateByQueryParams({
      [APP_QUERY_PARAMS.accountIds]: accounts,
      [APP_QUERY_PARAMS.siteIds]: sites,
    });
  }

  navigateBack(): void {
    return this.location.back();
  }

  navigateByUrl(url: string): Promise<boolean> {
    return this.router.navigateByUrl(url);
  }

  navigateByPeriod(period: string | null): Promise<boolean> {
    return this.navigateByQueryParams({ period });
  }

  navigateByQueryParams(
    queryParams: { [key: string]: number | string | null },
    queryParamsHandling: QueryParamsHandling = 'merge',
  ): Promise<boolean> {
    return this.router.navigate([], {
      queryParams,
      relativeTo: this.route,
      queryParamsHandling,
      replaceUrl: true,
    });
  }

  getCurrentUrlQueries(): Record<string, string> {
    const url = this.location.path(true);
    return this.getQueryParamsFromUrl(url);
  }

  getQueriesFromUrlByKeys(url: string, keys: string[]): Record<string, string> {
    const queries = this.getQueryParamsFromUrl(url);
    for (const key in queries) {
      if (!keys.includes(key)) delete queries[key];
    }
    return queries;
  }

  getQueryParamsFromUrl(url: string): Record<string, string> {
    const [, queryString] = url.split('?');

    if (!queryString?.length) {
      return {};
    }

    return queryString.split('&').reduce(
      (acc, current) => {
        const [key, value] = current.split('=');
        acc[key] = value;
        return acc;
      },
      {} as Record<string, string>,
    );
  }
}
